import ConnectivityCheckoutWrapper from '@components/connectivity/ConnectivityCheckoutWrapper';
import { configureConnectivityStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
const store = configureConnectivityStore();
const ConnectivityCheckout = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(ConnectivityCheckoutWrapper, Object.assign({}, props))));
};
export default ConnectivityCheckout;
